import { put } from "redux-saga/effects";
import { USBDetectionAction } from "../action";
import { Client } from "utils/transport";
import { SOMETHING_WENT_WRONG } from "constants/staticText";
import { ExportCSV } from "utils/export-csv";
import dayjs from "dayjs";
import { hms } from "utils/timeConverter";
import { getDownloadTableViewColumns } from "utils/commonUtils";

const ExportData = (
  fileName,
  data,
  colunms,
  filterDate,
  teams,
  reportType,
  payload
) => {
  let result = [];
  const Generated = "Generated Date:-" + dayjs().format("DD-MM-YYYY hh:mm a");
  const generatedData = [
    fileName,
    teams.length > 0
      ? "Teams: - " + teams.join(",").replaceAll(",", "/")
      : "Teams: - " + "All Teams",
    "Date:-" + filterDate,

    Generated,
    colunms.join(),
  ];

  data.forEach((record) => {
    const user = payload.user_map_data?.[record.identity_id];
    const employeeName =
      !record?.first_name && !record?.last_name
        ? "--"
        : `${record.first_name} ${record.last_name}`;

    const dynamicValues = getDownloadTableViewColumns(
      payload.viewFields,
      user,
      payload.team_map_data
    );

    const fixedValues = [
      dayjs(record?.start_time).format("YYYY-MM-DD hh:mm A"),
      record?.event_type,
      record?.title.replaceAll(",", " "),
    ];
    generatedData.push(
      [employeeName, ...dynamicValues, ...fixedValues].join(",")
    );
  });
  result = generatedData;
  return result;
};
const getDownloadCSV = (action, data) => {
  const teamIds = action.payload.body.group_id.split(",");
  const selectTeamNames = action.payload.team_list_data
    .filter((item) => teamIds.includes(item.id))
    .map((item) => item.name);

  const date =
    dayjs(action?.payload.body.start_date).format("YYYY-MM-DD") +
    " To " +
    dayjs(action?.payload.body.end_date).format("YYYY-MM-DD");
  // Dynamic columns
  const dynamicFields = action.payload.viewFields || [];
  const dynamicHeaders = dynamicFields.map((field) => field.label);

  // Fixed headers
  const fixedHeaders = ["Timestamp", "Event Type", "Title"];

  const finalHeaders = [
    "Employee", // full name
    ...dynamicHeaders,
    ...fixedHeaders,
  ];

  const exdata = ExportData(
    "USB Detection Report List",
    data,
    finalHeaders,
    date,
    selectTeamNames,
    action.payload.body.report_type,
    action.payload
  );

  ExportCSV("USB_Detection_report_List_", exdata);
};
export function* fetchUSBDetectionSaga(action) {
  const config = {
    method: "POST",
    url: `query/events/usb_actions`,
    headers: {
      ...action.payload.headers,
    },
    data: { ...action.payload.body },
  };

  try {
    const response = yield Client.request(config);
    yield put(USBDetectionAction.fetchUSBDetectionSuccess(response.data));
  } catch (err) {
    let errorMessage = SOMETHING_WENT_WRONG;
    if (err.response?.status < 500) {
      errorMessage = err.response?.data?.errors?.[0]?.detail;
    }
    yield put(USBDetectionAction.fetchUSBDetectionFailed(errorMessage));
  }
}

export function* downloadUSBDetectionSaga(action) {
  const config = {
    method: "POST",
    url: `query/events/usb_actions`,
    headers: {
      ...action.payload.headers,
    },
    data: { ...action.payload.body },
  };

  try {
    const response = yield Client.request(config);
    const rows = response.data.data;
    const n = Math.floor(
      response.data.optional.total_records / action.payload.body.limit
    );

    for (let i = 0; i < n; i++) {
      const config = {
        method: "POST",
        url: `query/events/usb_actions`,
        headers: {
          ...action.payload.headers,
        },
        data: { ...action.payload.body, page: i + 2 },
      };
      const response = yield Client.request(config);
      rows.push(...response.data.data);
    }
    // if (response.data.status_code === 200) {
    yield put(USBDetectionAction.downloadUSBDetectionSuccess());
    getDownloadCSV(action, rows);
    // }
  } catch (err) {
    console.log(err);
    let errorMessage = SOMETHING_WENT_WRONG;
    if (err.response?.status < 500) {
      errorMessage = err.response?.data?.errors?.[0]?.detail;
    }
    yield put(USBDetectionAction.downloadUSBDetectionFailed(errorMessage));
  }
}
export function* fetchUSBDetectionReportSaga(action) {
  const config = {
    method: "POST",
    // url: `query/events/usb_actions`,
    url: `query/reports/ext_device_events`,
    headers: {
      ...action.payload.headers,
    },
    data: { ...action.payload.body },
  };

  try {
    const response = yield Client.request(config);
    yield put(USBDetectionAction.fetchUSBDetectionReportSuccess(response.data));
  } catch (err) {
    let errorMessage = SOMETHING_WENT_WRONG;
    if (err.response?.status < 500) {
      errorMessage = err.response?.data?.errors?.[0]?.detail;
    }
    yield put(USBDetectionAction.fetchUSBDetectionReportFailed(errorMessage));
  }
}

export function* downloadUSBDetectionReportSaga(action) {
  const config = {
    method: "POST",
    url: `query/reports/ext_device_events`,
    headers: {
      ...action.payload.headers,
    },
    data: { ...action.payload.body },
  };

  try {
    const response = yield Client.request(config);
    if (response.data.status_code === 200) {
      yield put(USBDetectionAction.downloadUSBDetectionReportSuccess());
      getDownloadCSV(action, response.data.data);
    }
  } catch (err) {
    console.log(err);
    let errorMessage = SOMETHING_WENT_WRONG;
    if (err.response?.status < 500) {
      errorMessage = err.response?.data?.errors?.[0]?.detail;
    }
    yield put(
      USBDetectionAction.downloadUSBDetectionReportFailed(errorMessage)
    );
  }
}
